module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive-585163fcf7ddb1b96d940da6c1a37263.png";